<template>
  <div class="table-responsive">
    <table :id="tableid" class="table">
      <tbody>
        <template v-for="(reason, index) in decisions">
          <tr v-if="decisions[index].checked">
            <td>
              <b v-html="$t('decisions.decisions')[index]"/>
            </td>
          </tr>
          <tr v-if="decisions[index].checked">
            <td>
              <span v-html="decisions[index].comment"/>
            </td>
          </tr>
        </template>
        <tr v-if="other_decisions.checked">
          <td>
            <b v-html="$t('decisions.other_decisions')"/>
          </td>
        </tr>
        <tr v-if="other_decisions.checked">
          <td>
            <span v-html="other_decisions.comment"/>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'DecisionsReport',

  props: {
    recipient: { required: true, type: Object },
    tableid: { required: true, type: String }
  },

  data: () => ({
    busy: false, // Show spinner in button or not.
    decisions: [],
    other_decisions: null,
    template: ''
  }),

  computed: {
    allDecisions () {
      return [ ...this.decisions, this.other_decisions ]
    },
    ...mapGetters({
      nationalities: 'nationalities/nationalities',
      user: 'auth/user'
    })
  },

  created () {
    this.template = this.createTemplate()
    this.initializeDecisions()
  },

  mounted () {
    this.load()
  },

  methods: {
    createDecision (comment) {
      return { checked: false, comment: comment }
    },

    /**
     * Create template date according to user's locale and country.
     */
    createTemplate () {
      const now = new Date().toUserLocaleString(this)

      return this.$t('decisions.template').join('\n').format([ now ])
    },
    /**
     * Initialize decisions.
     *
     * NOTE : 19 decisions (including one custom).
     */
    initializeDecisions () {
      for (let i = 0; i < 18; i++) {
        this.decisions.push(this.createDecision(this.template))
      }

      this.other_decisions = this.createDecision('')
    },

    /**
     * Load decisions from database.
     *
     * NOTE : As checkboxes values are stored in a suite of bits (11001001...),
     *        we have to check for each checkbox[index] if
     *        suite[length - 1 - index] == 1.
     *
     *        For that, we verify the condition by doing
     *        suite & 2^(index) == 2^(index) which returns true or false.
     */
    async load () {
      const decisions = this.allDecisions

      await axios.get(`/api/users/${this.recipient.id}/evaluations/decisions`)
        .then(function (response) {
          const data = response.data

          decisions.forEach((decision, index) => {
            let flag = Math.pow(2, index)

            // Is checkbox[index] checked ?
            decision.checked = (data.checks & flag) == flag

            // If checkbox is checked, also add its comment.
            if (decision.checked) {
              decision.comment = data.comments[index].replace(/(?:\r\n|\r|\n)/g, '<br />')
            }
          })
        })
        .catch(function (error) {
          console.error(error)
        })
    }

  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/DecisionsReport.vue